import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import {IBattle, VideoFile} from "../10. Battle/types";
import BattleVideoGenerator from "./BattleVideoGenerator";
import {ServerAPI} from "../1. Core/ServerAPI";
import NP from "../1. Core/NP";
import {secondsToTime} from "../10. Battle/Util";
import Label from "../1. Core/Controls/Label/Label";
import {showShareDialog} from "./func";
import TextField from "../1. Core/Controls/TextField/TextField";
import Button from "../1. Core/Controls/Button/Button";


export default class BattleVideoGeneratorDialog extends Dialog {
	private _Battle: IBattle;
	private _battleVideoGenerator: BattleVideoGenerator;
	private _timerLbl: Label;
	private startStreamDate: Date;
	private _streamTimeId: any;
	private _progressLabel: Label;


	_initFields(settings: object)
	{
		this._Battle = null;
		super._initFields(settings);
		this._AutoDestroy = true;
		this._Caption = "Video Highlight Creator";
		this._ShowHeader = true;
		this._Mode = 'FullScreen';
		this._ShowButtons = false
	}

	async _render()
	{
		super._render();
		this.setCaption(this._Battle.RedName + ' vs ' + this._Battle.BlueName);

		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		this._battleVideoGenerator = new BattleVideoGenerator({
			Battle: this._Battle,
			ParentNode: this._contentNode
		})

		this.getTopAppBar().addItem(this._timerLbl = new Label() as any, this._okButton);
		this._timerLbl.getRoot().style.color = 'black';
		this.getTopAppBar().addItem(this._progressLabel = new Label() as any, this._okButton);
		this._progressLabel.getRoot().style.color = 'black';

		this._okButton.setRK('StartCreateVideo');

		this.getTopAppBar().addItem(new Button({
			Content: 'Cut intervals',
			EvClick: () => this.doCreateVideo(null, true)
		}), this._okButton);
	}

	async _onOkButtonClick()
	{
		(new Dialog({
			Content: new TextField({
				FloatingLabel: 'Enter name of the video',
				Value: this._battleVideoGenerator.getVideoType()
			}),
			EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) =>
			{
				let name = dlg.getContent().getValue().trim();
				if (name)
				{
					dlg.hide()
					this.doCreateVideo(name)
				}
				else
					args.IsCancelClose = true
			}
		})).show()
	}

	async doCreateVideo(name: string, isCutIntervals: boolean = false)
	{
		this._topAppBar.showWaiter()
		try
		{
			this.startStreamDate = new Date();
			this._streamTimeId = setTimeout(() => this.recalcDate(), 1000);
			setTimeout(() => this.recalcProgress(), 1000);
			this._timerLbl.setContent('00:00');

			this._Battle.VideoStartTime = this._battleVideoGenerator._videoStartWorldTimeInput.getValue();
			await ServerAPI.post(`/battle/updateTimes/${this._Battle.Id}`, this._Battle)

			let res = await ServerAPI.post<VideoFile>("/video/createBattleVideo", {
				name: name,
				battleId: this._Battle.Id,
				funnyList: this._battleVideoGenerator.getFunnyList(),
				rows: this._battleVideoGenerator.getSelectedActionList(),
				addPreviewVideo: this._battleVideoGenerator.getRoundPreviewVideo(),
				addFirstPreviewVideo: this._battleVideoGenerator.getFirstPreviewVideo(),
				compressAndSort: true,
				videoStartTime: this._battleVideoGenerator.getVideoWorldStartWorldTime(),
				videoType: this._battleVideoGenerator.getVideoType(),
				previewType: this._battleVideoGenerator.getPreviewType(),
				transitionType: this._battleVideoGenerator.getTransitionType(),
				isRelativeTimeStart: this._battleVideoGenerator.isRelativeTimeStart(),
				addWallpaperToEnd: this._battleVideoGenerator.getAddWallpaperToEnd(),
				prepareIntervalsOnly: isCutIntervals === true
			})

			if (res)
			{
				res.Name = this._Battle.Name
				showShareDialog(res)
			}
			else
			{
				NP.showMessage({Content: 'Done'});
				if (isCutIntervals)
					this._battleVideoGenerator.refreshDataTable()
			}
		} finally
		{
			this.startStreamDate = null;
			this._topAppBar.hideWaiter();
		}
	}

	async recalcDate()
	{
		if (this.startStreamDate)
		{
			let t = new Date().getTime() - this.startStreamDate.getTime();
			this._timerLbl.setContent(secondsToTime(t / 1000));

			this._streamTimeId = setTimeout(() => this.recalcDate(), 800);
		}
	}

	async recalcProgress()
	{
		let info = await ServerAPI.get<{ message: string }>(`/video/getCreateHLProgress/${this._Battle.Id}`)
		if (info)
		{
			this._progressLabel.setContent(' ' + info.message)
			setTimeout(() => this.recalcProgress(), 1000);
		}
		else
			this._progressLabel.setContent('')
	}

	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);
		this._battleVideoGenerator?.setHeight(value - 64 - 25);
	}
}

